/*
 * @Author: yeyimei
 * @Date: 2022-09-22 17:09:10
 * @LastEditTime: 2023-11-20 11:14:55
 * @LastEditors: yeyimei
 * @Description:
 * @FilePath: \cardlan-h5-qrcode\src\main.js
 */
import { createApp } from "vue"
import App from "./App.vue"
import router from "./router"
import store from "./store"
import "lib-flexible/flexible.js"
import "vant/lib/index.css"
import Vant from "vant"
import "@/assets/iconfont/iconfont.css"
import { Lazyload } from "vant"
import { getAppIdStorage, setAppIdStorage, getStorage } from "./libs/storage"
import VueWechatTitle from "vue-wechat-title"
import dayjs from "dayjs"
import { VueMasonryPlugin } from "vue-masonry"
import { handlePrice } from "@/libs/tools"
import config from "@/libs/config/config"

//百度统计
// var _hmt = _hmt || []
// window._hmt = _hmt // 修改为window 全局变量
// ;(function () {
//   var hm = document.createElement("script")
//   hm.src = "https://hm.baidu.com/hm.js?951f0c46ca979e69176ed7fb69e25a97"
//   var s = document.getElementsByTagName("script")[0]
//   s.parentNode.insertBefore(hm, s)
// })()

let appId = getStorage("appId") || "wx9a373b1354d442cf"
let infos_storage = getAppIdStorage(appId) || {}
infos_storage.iosPath = window.localStorage.href
setAppIdStorage(appId, infos_storage)

const app = createApp(App)
//土特产：wxfcb34416b1538017  H5：wx9a373b1354d442cf
app.config.globalProperties.$config = config
app.config.globalProperties.$dayjs = dayjs //全局使用dayjs
app.config.globalProperties.$handlePrice = handlePrice //处理商城价格金额

app
  .use(store)
  .use(router)
  .use(Vant)
  .use(Lazyload, {
    lazyComponent: true,
  })
  .use(VueMasonryPlugin)
  .use(VueWechatTitle)
  .mount("#app")
